import { useState } from 'react';

import { Stack } from '@mui/material';

import ContentBuilderRow from 'domains/core/components/ContentBuilderRow';
import { NoResponseAction, VoiceContentStateTypes } from 'pages/ContentVoiceBuilderPage/types';

import NoResponseActionSelect from './NoResponseActionSelect';
import RepeatSelect from './RepeatSelect';
import TimeoutMessageToggle from './TimeoutMessageToggle';
import WaitTimeSelect from './WaitTimeSelect';

type Props = {
    dispatchVoiceContentAction: React.Dispatch<any>;
    isContentLoading: boolean;
    voiceContentState: VoiceContentStateTypes;
};

const NoResponseRow = ({ dispatchVoiceContentAction, isContentLoading, voiceContentState: state }: Props) => {
    const repeatValue = state.voiceJson.fallback?.repeat ?? null;
    const getNoResponseAction = () => {
        if (repeatValue === null) return null;
        if (repeatValue === 0) return NoResponseAction.HANG_UP;
        if (repeatValue === 1 || repeatValue === 2) return NoResponseAction.REPEAT;
    };
    const selectedAction = getNoResponseAction();
    const [noResponseAction, setNoResponseAction] = useState(selectedAction);

    return (
        <ContentBuilderRow
            title="No Response Settings"
            subtitle="Set fallbacks like wait time and default messages to keep the call going, even if there's no response."
            content={
                <Stack rowGap={2}>
                    <Stack columnGap={2} direction="row">
                        <WaitTimeSelect
                            dispatchVoiceContentAction={dispatchVoiceContentAction}
                            isContentLoading={isContentLoading}
                            voiceContentState={state}
                        />
                        <NoResponseActionSelect
                            dispatchVoiceContentAction={dispatchVoiceContentAction}
                            isContentLoading={isContentLoading}
                            noResponseAction={noResponseAction}
                            setNoResponseAction={setNoResponseAction}
                        />
                        {noResponseAction === NoResponseAction.REPEAT && (
                            <RepeatSelect
                                dispatchVoiceContentAction={dispatchVoiceContentAction}
                                isContentLoading={isContentLoading}
                                repeatValue={repeatValue}
                            />
                        )}
                    </Stack>
                    <TimeoutMessageToggle
                        dispatchVoiceContentAction={dispatchVoiceContentAction}
                        isContentLoading={isContentLoading}
                        voiceContentState={state}
                    />
                </Stack>
            }
        />
    );
};

export default NoResponseRow;
